"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LastButton = exports.FirstButton = exports.NextButton = exports.PreviousButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _DarkButton = _interopRequireDefault(require("../Button/DarkButton"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _styles = _interopRequireDefault(require("./styles"));

var PreviousButton = function PreviousButton(_ref) {
  var current = _ref.current,
      firstPage = _ref.firstPage,
      onClick = _ref.onClick,
      theme = _ref.theme;
  return _react.default.createElement(_DarkButton.default.IconButton, {
    onClick: onClick,
    disabled: current === firstPage,
    className: _styles.default.buttonContainer
  }, _react.default.createElement(_Icon.default, {
    type: "arrowLeftNew",
    style: {
      fill: theme.color.dark.zinc,
      height: '18px'
    }
  }));
};

exports.PreviousButton = PreviousButton;

var NextButton = function NextButton(_ref2) {
  var current = _ref2.current,
      lastPage = _ref2.lastPage,
      onClick = _ref2.onClick,
      theme = _ref2.theme;
  return _react.default.createElement(_DarkButton.default.IconButton, {
    onClick: onClick,
    disabled: current === lastPage,
    className: _styles.default.buttonContainer
  }, _react.default.createElement(_Icon.default, {
    type: "arrowRightNew",
    style: {
      fill: theme.color.dark.zinc,
      height: '18px'
    }
  }));
};

exports.NextButton = NextButton;

var FirstButton = function FirstButton(_ref3) {
  var current = _ref3.current,
      firstPage = _ref3.firstPage,
      onClick = _ref3.onClick,
      theme = _ref3.theme;
  return _react.default.createElement(_DarkButton.default.IconButton, {
    onClick: onClick,
    disabled: current === firstPage,
    className: _styles.default.buttonContainer
  }, _react.default.createElement("span", {
    className: _styles.default.verticalLine(theme, true)
  }), _react.default.createElement(_Icon.default, {
    type: "arrowLeftNew",
    style: {
      fill: theme.color.dark.zinc,
      height: '18px'
    }
  }));
};

exports.FirstButton = FirstButton;

var LastButton = function LastButton(_ref4) {
  var current = _ref4.current,
      lastPage = _ref4.lastPage,
      onClick = _ref4.onClick,
      theme = _ref4.theme;
  return _react.default.createElement(_DarkButton.default.IconButton, {
    onClick: onClick,
    disabled: current === lastPage,
    className: _styles.default.buttonContainer
  }, _react.default.createElement(_Icon.default, {
    type: "arrowRightNew",
    style: {
      fill: theme.color.dark.zinc,
      height: '18px'
    }
  }), _react.default.createElement("span", {
    className: _styles.default.verticalLine(theme, false)
  }));
};

exports.LastButton = LastButton;